/**
 * Created by Administrador on 25/09/2019.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('specialInvoices', {
                parent: 'app',
                url: '/specialInvoices?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/specialInvoice/specialInvoices.html',
                        controller: 'specialInvoiceCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['specialInvoice']);
                            }],
                            specialInvoices: ['specialInvoiceService','$stateParams', function(specialInvoiceService, $stateParams){
                                return specialInvoiceService.getPageSpecialInvoices($stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
            .state('specialInvoiceNew', {
                parent: 'app',
                url: '/specialInvoice/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/specialInvoice/newSpecialInvoice.html',
                        controller: 'newSpecialInvoiceCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['specialInvoice']);
                            }],
                            'documentTypes': ['documentTypeService', function(documentTypeService) {
                                return documentTypeService.getDocumentTypeAndMeasureUnit();
                            }],
                            'activities': ['siatService', function(siatService) {
                                return siatService.getActivities();
                            }],
                            'products': ['siatService', function(siatService) {
                                return siatService.getProducts();
                            }]
                        }
                    }
                }
            })
            .state('specialInvoiceView', {
                parent: 'app',
                url: '/specialInvoice/:id/view',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/specialInvoice/viewSpecialInvoice.html',
                        controller: 'viewSpecialInvoiceCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['specialInvoice']);
                            }],
                            'specialInvoice': ['specialInvoiceService', '$stateParams', function(specialInvoiceService, $stateParams) {
                                return specialInvoiceService.getSpecialInvoice($stateParams.id);
                            }]
                        }
                    }
                }
            })
            .state('specialInvoiceAnnular', {
                parent: 'specialInvoices',
                url: '/specialInvoice/:id/annular:/:numberInvoice',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/finance/specialInvoice/annularSpecialInvoice.html',
                        controller: 'annularSpecialInvoiceCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['specialInvoice']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('specialInvoices', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
